import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import Link from 'components/link';
import { useRoute } from 'hooks/navigation/use-route';
import { useFormatCalories } from 'hooks/use-format-calories';
import {
  MenuSectionContent,
  MenuSectionImage,
  MenuSectionImageWrapper,
  MenuSectionItemCalories,
  MenuSectionItemPrice,
  MenuSectionProductWrapper,
  MenuSectionRow,
  MenuSectionTitle,
} from 'pages/menu/components/menu-section/styled';
import { IMenuSectionItemProps } from 'pages/menu/components/menu-section/types';
import { emitTileClickedEvent } from 'pages/menu/components/menu-tile-grid/menu-tile/helpers';
import { buildMenuLink } from 'pages/menu/utils/navigation';
import { ClickEventComponentNames, logButtonClick } from 'state/amplitude';
import { useUIContext } from 'state/ui';
import { EventName, emitEvent } from 'utils/event-hub';
import { routes } from 'utils/routing';

// NEW one menu
export const MenuSectionListItem: React.FC<IMenuSectionItemProps> = ({
  item,
  objectFitContain,
}) => {
  const { pathname } = useRoute<{ id?: string }>();
  const { formatMessage } = useIntl();
  const { formatCurrencyForLocale } = useUIContext();
  const formatCalories = useFormatCalories();

  const linkPath = buildMenuLink(item);

  const handleLinkClick = useCallback(() => {
    const attributes = {
      component: !item.product
        ? ClickEventComponentNames.PRODUCT_SECTION_TILES
        : ClickEventComponentNames.PRODUCTS,
      name: item.name,
      componentId: item.id,
    };

    logButtonClick({ attributes }, { logDuplicateClickEvent: true });
    emitTileClickedEvent({
      pathname,
      sanityId: item.id,
    });
  }, [item, pathname]);

  const handleOnImageLoaded = useCallback(() => {
    emitEvent(EventName.MENU_TILE_IMAGE_LOADED, {
      sanityId: item.id,
      isOnMainMenu: pathname === routes.menu,
      attributes: [],
    });
  }, [item.id, pathname]);

  return (
    <Link key={item.id} onPress={handleLinkClick} linkPath={linkPath} dd-action-name={item.name}>
      <MenuSectionRow testID="menu-tile-bk">
        <MenuSectionImageWrapper>
          <MenuSectionImage
            image={item.image.resource}
            alt={item.image.description}
            onImageLoaded={handleOnImageLoaded}
            objectFitContain={objectFitContain}
            accessibilityHint={formatMessage({ id: 'select' })}
          />
        </MenuSectionImageWrapper>
        <MenuSectionContent>
          <MenuSectionTitle testID={`tile-header-${item.name?.toLowerCase().replace(/\s/g, '')}`}>
            {item.name}
          </MenuSectionTitle>
          {item.product && (
            <MenuSectionProductWrapper>
              <MenuSectionItemPrice>
                {formatCurrencyForLocale(item.product.price)}
              </MenuSectionItemPrice>
              <MenuSectionItemCalories>
                {formatCalories(item.product.calories)}
              </MenuSectionItemCalories>
            </MenuSectionProductWrapper>
          )}
        </MenuSectionContent>
      </MenuSectionRow>
    </Link>
  );
};
